import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { actionSet } from './utils'
import { getPages } from 'component/pagination/utils'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_USAGE_CONSUMPTION_REPORT_REQUEST,
  FETCH_USAGE_CONSUMPTION_REPORT_SUCCESS,
  FETCH_USAGE_CONSUMPTION_REPORT_ERROR,
  FETCH_USAGE_CONSUMPTION_STATUS_REQUEST,
  FETCH_USAGE_CONSUMPTION_STATUS_SUCCESS,
  FETCH_USAGE_CONSUMPTION_STATUS_ERROR,
} from 'actionTypes'

export const fetch = (token, param) => async (dispatch) => {
  dispatch(showSpinner())
  try {
    dispatch(actionSet(FETCH_USAGE_CONSUMPTION_REPORT_REQUEST))

    const response = await new Api(token, dispatch).post(
      API_URL.USAGE_CONSUMPTION_REPORT,
      param
    )

    dispatch(getPages(response.metadata))

    return dispatch(
      actionSet(FETCH_USAGE_CONSUMPTION_REPORT_SUCCESS, response.data)
    )
  } catch (error) {
    return dispatch(actionSet(FETCH_USAGE_CONSUMPTION_REPORT_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}

export const fetchUsageConsumptionStatus = (token) => async (dispatch) => {
  dispatch(showSpinner())
  try {

    dispatch(actionSet(FETCH_USAGE_CONSUMPTION_STATUS_REQUEST))

    const response = await new Api(token, dispatch).get(
      API_URL.FETCH_USAGE_CONSUMPTION_STATUS
    )

    return dispatch(
      actionSet(FETCH_USAGE_CONSUMPTION_STATUS_SUCCESS, response.data)
    )
  } catch (error) {
    return dispatch(actionSet(FETCH_USAGE_CONSUMPTION_STATUS_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}
